module.exports = __webpack_public_path__ + "static/img/ad1.91a883d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad1.png
// module id = ZE3s
// module chunks = 7